import Flickity from "flickity";
import { getElement, getElements } from "./utils/getElement";

const initOfferCarousels = () => {
    const carousel = getElement('.js-carousel-offers');

    if (carousel) {

        const isMobile = window.matchMedia('(max-width: 992px)').matches;

        const flickityInstance = new Flickity(carousel, {
            cellAlign: isMobile ? 'center' : 'right',
            setGallerySize: false,
            contain: true,
            imagesLoaded: true,
            prevNextButtons: false,  // we'll handle prev/next ourselves
            pageDots: false,
            wrapAround: true,
            groupCells: isMobile ? false : 3,
        });

        const resizeCards = () => {
            const carouselCards = getElements('.c-carousel__slide');
            if (!carouselCards.length) return;

            // Reset heights
            carouselCards.forEach(el => {
                const card = el.querySelector('.c-card--product');
                if (card) card.style.height = 'auto';
            });

            // Find tallest height
            let maxHeight = 0;
            carouselCards.forEach(el => {
                const card = el.querySelector('.c-card--product');
                if (card) {
                    const elHeight = card.offsetHeight;
                    if (elHeight > maxHeight) maxHeight = elHeight;
                }
            });

            // Apply tallest height
            carouselCards.forEach(el => {
                const card = el.querySelector('.c-card--product');
                if (card) card.style.height = `${maxHeight}px`;
            });

            // Trigger Flickity resize
            flickityInstance.resize();
        };

        // Initial sizing
        resizeCards();

        // Window resize listener (debounced)
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => resizeCards(), 150);
        });

        // Example: hook up your prev / next buttons:
        const btnPrev = getElement('.js-offers-carousel-prev');
        const btnNext = getElement('.js-offers-carousel-next');

        if (btnPrev) {
            btnPrev.addEventListener('click', () => {
                // Move to previous slide
                flickityInstance.previous();
            });
        }
        if (btnNext) {
            btnNext.addEventListener('click', () => {
                // Move to next slide
                flickityInstance.next();
            });
        }


        // Move element between desktop and mobile containers dynamically
        const moveCarouselNav = () => {
            const mobileContainer = document.querySelector('.js-mobile-carousel-nav');
            const desktopContainer = document.querySelector('.js-desktop-carousel-nav');
            const navElement = document.querySelector('.js-carousel-nav'); // The element you want to move

            if (!navElement || !mobileContainer || !desktopContainer) return;

            const isMobile = window.matchMedia('(max-width: 768px)').matches;

            if (isMobile && !mobileContainer.contains(navElement)) {
                // Move to mobile container
                mobileContainer.appendChild(navElement);
            } else if (!isMobile && !desktopContainer.contains(navElement)) {
                // Move to desktop container
                desktopContainer.appendChild(navElement);
            }
        };


        window.addEventListener('load', moveCarouselNav);


        let resizeTimeoutNav;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeoutNav);
            resizeTimeoutNav = setTimeout(moveCarouselNav, 200);
        });

    }
};

export { initOfferCarousels };
